import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableQarzeRastawxo from "./ScroollTableQarzeRastawxo";
import FooterOfQarzRastawxo from "./FooterOfQarzRastawxo";
import FillDetailQarzRastawxo from "./FillDetailQarzRastawxo";
const AllQarzRastawxo = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailQarzRastawxo />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScroollTableQarzeRastawxo />
          </div>
        </div>
        <div className="row " style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 col-12">
            <FooterOfQarzRastawxo />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllQarzRastawxo;
